import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { orchestrator } from 'satcheljs';
import {
    switchToReadWriteRecipientWell,
    enableOptionalAttendeesWell,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(switchToReadWriteRecipientWell, actionMessage => {
    const { formId } = actionMessage;
    const { OptionalAttendees } = getComposeEvent(formId);

    if (OptionalAttendees?.length > 0) {
        enableOptionalAttendeesWell(formId);
    }
});
